import {makeStyles} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flex: '1 1 100%',
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const Index = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img
        src={require('../../assets/images/cargo/loading.gif').default}
        alt=''
        width={100}
      />
    </div>
  );
};

export default Index;
